import React from "react";
import { Car } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Card, CardHeader, CardTitle, CardContent } from "../../ui";
import { VehicleSearchField } from "../fields/VehicleSearchField";
import { Vehicle } from "../../../types";
import { VehicleIdentityCard } from "@/components/vehicles/VehicleIdentityCard";
import { type VehicleIdentityData } from "@/components/vehicles/vehicleIdentity";

interface VehicleSectionProps {
 vehicleId: string;
 selectedVehicle: Vehicle | null;
 onVehicleChange: (vehicleId: string) => void;
 onVehicleRemove: () => void;
}

export const VehicleSection: React.FC<VehicleSectionProps> = ({
 vehicleId,
 selectedVehicle,
 onVehicleChange,
 onVehicleRemove,
}) => {
 const { t } = useTranslation();

 return (
 <Card>
 <CardHeader>
 <CardTitle className="flex items-center gap-2">
 <Car className="h-5 w-5" />
 {t('proposals.form.vehicle')}
 </CardTitle>
 </CardHeader>
 <CardContent className="space-y-4">
 <VehicleSearchField
 value={vehicleId}
 onChange={onVehicleChange}
 placeholder={t('proposals.form.searchVehicle')}
 />

 {selectedVehicle && (
<VehicleIdentityCard
vehicle={selectedVehicle as unknown as VehicleIdentityData}
variant="selected"
onRemove={onVehicleRemove}
removeTitle={t('leads.autoTransfer.removeVehicle')}
/>
 )}
 </CardContent>
 </Card>
 );
};

